import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { Tabs, Tab, Box, Typography, TableContainer } from "@mui/material";
import image from "../../logos/content library.png";
import "../../components/CommonDashboard.css";
import { setCurrentEmms } from "../../redux/slices/currentEmmsSlice";
import { setEmmsHeaders } from "../../redux/slices/emmsAuthSlice";
import EventCustomisationTable from "./EventCustomisationTable";
import DmzTable from "./DmzTable";
import Login from "../Login";
import TitleWithDropdown from "../TitleWithDropdown";
import MyEventCustomisationForm from "./MyEventCustomisationForm";
import { setEventcustomisation } from "../../redux/slices/eventcustomisationsSlice";
import { setDmz } from "../../redux/slices/dmzSlice";
import { setMaxLimit } from "../../redux/slices/maxLimitSlice";
import {
  seteventcustomisationglobalupdate,
  seteventcustomisationglobalupdatelogout,
} from "../../redux/slices/eventCustomisationGlobalUpdateSlice";

function ContentLibraryDashboard({ selected }) {
  const dispatch = useDispatch();
  const emms = useSelector((state) => state.emms);
  const [login, setLogin] = useState(false);
  const [selectedOption, setSelectedOption] = useState(emms?.emms?.[0]?.id);
  const [selectedTab, setSelectedTab] = useState(0); 
  const eventglobalconfigurationupdate = useSelector(
    (state) =>
      state?.eventcustomisationglobalupdate?.eventcustomisationglobalupdate
  );
  const headers = useSelector((state) => state.header);
  const [errors, setErrors] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isDmzLoading, setIsDmzLoading] = useState(true);

  function fetchData(value) {
    setIsLoading(true);
    const api = localStorage.getItem("api");
    let selectedEmms = emms?.emms?.find((element) => element.id === value);

    if (selectedEmms !== null) {
      const apiId = selectedEmms?.apiId;
      const apiKey = selectedEmms?.apiKey;
      dispatch(setCurrentEmms(selectedEmms));

      const emmsheaders = {
        headers: {
          "Content-Type": "application/json",
          "x-api-id": apiId,
          "x-api-key": apiKey,
        },
      };

      dispatch(setEmmsHeaders(emmsheaders));

      const requestBody = {
        path: "list/eventcustomisations",
        query: {},
        emmsId: value,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };

      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          const sortedData = response?.data?.sort(
            (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
          );
          dispatch(setEventcustomisation(sortedData));
          setErrors(false);
        })
        .catch((error) => {
          console.error(error);
          setErrors(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }
  const parseSize = (sizeStr) => {
    const unitMap = { kb: 1024, mb: 1024 * 1024, gb: 1024 * 1024 * 1024 };
    const match = sizeStr.match(/^(\d+)(kb|mb|gb)$/);
    if (match) {
      const size = parseInt(match[1], 10);
      const unit = match[2];
      return size * unitMap[unit];
    }
    return 2 * 1024 * 1024 * 1024;
  };
  function fetchDmzData(value) {
    setIsDmzLoading(true);
    const api = localStorage.getItem("api");
    let selectedEmms = emms?.emms?.find((element) => element.id === value);

    if (selectedEmms !== null) {
      const apiId = selectedEmms?.apiId;
      const apiKey = selectedEmms?.apiKey;
      dispatch(setCurrentEmms(selectedEmms));

      const emmsheaders = {
        headers: {
          "Content-Type": "application/json",
          "x-api-id": apiId,
          "x-api-key": apiKey,
        },
      };

      dispatch(setEmmsHeaders(emmsheaders));

      const requestBody = {
        path: "list/dmz",
        query: {},
        emmsId: value,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };

      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          const sortedData = response?.data?.data?.sort(
            (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
          );

          dispatch(setDmz(sortedData));

          const maxLimitStr = response.data.additionalInfo.toLowerCase();
          const maxLimitInBytes = parseSize(maxLimitStr);

          dispatch(setMaxLimit(maxLimitInBytes));

          setErrors(false);
        })
        .catch((error) => {
          console.error(error);
          setErrors(true);
        })
        .finally(() => {
          setIsDmzLoading(false);
        });
    }
  }

  useEffect(() => {
    fetchData(selectedOption);
    fetchDmzData(selectedOption);

    if (eventglobalconfigurationupdate) {
      setTimeout(() => {
        dispatch(seteventcustomisationglobalupdate(false));
      }, 100);
    }
  }, [eventglobalconfigurationupdate]);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    fetchData(event.target.value);
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const options = emms?.emms?.map((emm) => ({
    label: emm.name,
    value: emm.id,
  }));

  return login == null ? (
    <Login />
  ) : (
    <>
      <div className="mainContainer emms-main-container">
        <header className="emms-main-container-left-align" style={{ marginLeft: "10%" }}>
          <figure className="emms-image-figure" >
            <img className="img emm-image content-ai-header-image" src={image} alt="Logo" />
          </figure>
        </header>
        <div className="title-container">
          <div className="title">
            <TitleWithDropdown
              title="EMMS Service"
              options={options}
              selectedOption={selectedOption}
              onOptionChange={handleOptionChange}
            />
          </div>
          <div>
            <MyEventCustomisationForm selectedOption={selectedOption} />
          </div>
        </div>

        <Box sx={{ width: "100%" ,marginTop:{xs:"6px",md:"unset"}}}>
          <Tabs value={selectedTab} onChange={handleTabChange} centered>
            <Tab label="Custom" />
            <Tab label="DMZ Table" />
            <Tab label="Content AI" />
          </Tabs>
        </Box>

      
        <TableContainer className="emms-main-container-left-align-content-library" style={{ marginLeft:{xs:"0%", md:"5%"}, overflowY: "auto" }}>
          {selectedTab === 0 ? (
            <EventCustomisationTable
              selectedOption={selectedOption}
              errors={errors}
              isLoading={isLoading}
              dataType="custom" 
            />
          ) : selectedTab === 1 ? (
            <DmzTable selectedOption={selectedOption} errors={errors} isLoading={isDmzLoading} />
          ) : (
            <EventCustomisationTable
              selectedOption={selectedOption}
              errors={errors}
              isLoading={isLoading}
              dataType="contentAI" 
            />
          )}
        </TableContainer>
      </div>
    </>
  );
}

export default ContentLibraryDashboard;
